import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { someMap as t } from "../../core/MapUtils.js";
import { clamp as e } from "../../core/mathUtils.js";
import { isNone as i, isSome as o, applySome as r, unwrap as n } from "../../core/maybe.js";
import { createScreenPoint as a } from "../../core/screenUtils.js";
import { areToolManipulatorsEditable as s } from "./interactiveToolUtils.js";
import { createScreenPointFromEvent as l } from "../support/screenUtils.js";

var p = /*#__PURE__*/function () {
  function p() {
    _classCallCheck(this, p);

    this._pointerLocations = new Map(), this._hoveredManipulators = new Map(), this._grabbedManipulators = new Map(), this._draggedManipulators = new Map(), this._stopDrag = !1, this._currentlyActiveTool = null, this._revertToActiveTool = !1, this._cursor = null;
  }

  _createClass(p, [{
    key: "cursor",
    get: function get() {
      return this._cursor;
    }
  }, {
    key: "handleInputEvent",
    value: function handleInputEvent(t, a) {
      var s = function s() {
        return t.stopPropagation();
      };

      switch (t.type) {
        case "pointer-move":
          c(t.pointerType) && this._pointerLocations.set(t.pointerId, {
            x: t.x,
            y: t.y,
            pointerType: t.pointerType
          });
          break;

        case "drag":
          this._grabbedManipulators.size > 0 && (this._stopDrag = !0), this._stopDrag && (s(), "end" === t.action && (this._stopDrag = !1));
          break;

        case "pointer-down":
          {
            if (!u(t)) break;

            var _e = l(t),
                _n = this._intersect(_e, t.pointerType, a.forEachTool);

            if (i(_n)) break;

            var _p5 = this._findToolAndManipulatorByKey(_n, a.forEachTool, h),
                _c = r(_p5, function (t) {
              return t.manipulator;
            }),
                _d = r(_p5, function (t) {
              return t.tool;
            });

            !(o(_c) && o(_d) && _c.interactive) || _c.grabbable && _c.grabbableForEvent(t) || !_c.grabbing || _c.dragging || this._ungrabManipulatorBeforeDragging(_c, _d, t), o(_c) && _c.interactive && _c.grabbable && _c.grabbableForEvent(t) && !_c.grabbing && (this._grabbedManipulators.set(t.pointerId, {
              key: _n,
              start: _e,
              pointerType: t.pointerType
            }), 1 === this._grabbedManipulators.size && a.activeTool !== _n.tool && (this._currentlyActiveTool = a.activeTool, this._revertToActiveTool = !0, a.setActiveTool(_n.tool)), _c.grabbing = !0, _c.events.emit("grab-changed", {
              action: "start",
              pointerType: t.pointerType,
              screenPoint: _e
            }), s());
            break;
          }

        case "pointer-up":
          this._handlePointerEnd(t, a);

          break;

        case "pointer-drag":
          {
            if (!u(t)) break;

            var _o = this._grabbedManipulators.get(t.pointerId),
                _p6 = this._draggedManipulators.get(t.pointerId),
                _c2 = r(_o || _p6, function (_ref) {
              var t = _ref.key;
              return t;
            }),
                _d2 = this._findManipulatorByKey(_c2, a.forEachTool);

            if (i(_d2)) break;

            var _h = l(t);

            _h.x = e(_h.x, 0, a.view.width), _h.y = e(_h.y, 0, a.view.height);
            var g = n(_o || _p6).start;

            switch (t.action) {
              case "start":
              case "update":
                "update" !== t.action && 1 !== this._grabbedManipulators.size || (_d2.dragging = !0, _p6 ? _d2.events.emit("drag", {
                  action: "update",
                  start: g,
                  screenPoint: _h
                }) : _d2.events.emit("drag", {
                  action: "start",
                  start: g,
                  screenPoint: _h,
                  pointerType: t.pointerType
                }), this._draggedManipulators.set(t.pointerId, {
                  key: n(_c2),
                  start: g
                }));
                break;

              case "end":
                _d2.dragging = !1, _p6 && _d2.events.emit("drag", {
                  action: "end",
                  start: g,
                  screenPoint: _h
                }), this._draggedManipulators.delete(t.pointerId), this._handlePointerEnd(t, a);
            }

            s();
            break;
          }

        case "immediate-click":
          {
            var _e2 = l(t),
                _r = this._intersect(_e2, t.pointerType, a.forEachTool),
                _n2 = this._findToolAndManipulatorByKey(_r, a.forEachTool, h);

            if (d(t) || a.forEachTool(function (t) {
              if ((!o(_n2) || _n2.tool !== t || t.automaticManipulatorSelection) && t.manipulators) {
                var _e3 = !1;

                t.manipulators.forEach(function (_ref2) {
                  var t = _ref2.manipulator;
                  t.selected && (t.selected = !1, _e3 = !0);
                }), _e3 && t.manipulatorSelectionChanged && t.manipulatorSelectionChanged();
              }
            }), i(_n2)) break;
            var _p7 = _n2.manipulator,
                _c3 = _n2.tool;
            if (!_p7.interactive) break;
            _p7.selectable && _c3.automaticManipulatorSelection && (_p7.selected = !_p7.selected, _c3.manipulatorSelectionChanged && _c3.manipulatorSelectionChanged());
            var _u = t.native.shiftKey;

            _p7.events.emit("immediate-click", {
              screenPoint: _e2,
              button: t.button,
              pointerType: t.pointerType,
              shiftKey: _u,
              stopPropagation: s
            });

            break;
          }

        case "click":
          {
            var _e4 = l(t),
                _o2 = this._intersect(_e4, t.pointerType, a.forEachTool),
                _r2 = this._findManipulatorByKey(_o2, a.forEachTool);

            if (i(_r2) || !_r2.interactive) break;
            var _n3 = t.native.shiftKey;
            _r2.events.emit(t.type, {
              screenPoint: _e4,
              button: t.button,
              pointerType: t.pointerType,
              shiftKey: _n3
            }), s();
            break;
          }

        case "double-click":
          {
            var _e5 = l(t),
                _o3 = this._intersect(_e5, t.pointerType, a.forEachTool),
                _r3 = this._findManipulatorByKey(_o3, a.forEachTool);

            if (i(_r3) || !_r3.interactive) break;
            var _n4 = t.native.shiftKey;

            _r3.events.emit("double-click", {
              screenPoint: _e5,
              button: t.button,
              pointerType: t.pointerType,
              shiftKey: _n4,
              stopPropagation: s
            });

            break;
          }

        case "immediate-double-click":
          {
            var _e6 = l(t),
                _o4 = this._intersect(_e6, t.pointerType, a.forEachTool),
                _r4 = this._findManipulatorByKey(_o4, a.forEachTool);

            if (i(_r4) || !_r4.interactive) break;
            var _n5 = t.native.shiftKey;

            _r4.events.emit("immediate-double-click", {
              screenPoint: _e6,
              button: t.button,
              pointerType: t.pointerType,
              shiftKey: _n5,
              stopPropagation: s
            });

            break;
          }
      }

      this._updateCursor(a.forEachTool);
    }
  }, {
    key: "_ungrabManipulatorBeforeDragging",
    value: function _ungrabManipulatorBeforeDragging(t, e, i) {
      var _this = this;

      t.grabbing = !1, t.events.emit("grab-changed", {
        action: "end",
        pointerType: i.pointerType,
        screenPoint: l(i)
      }), this._grabbedManipulators.forEach(function (_ref3, o) {
        var i = _ref3.key;
        i.tool === e && e.manipulators.findById(i.manipulatorId) === t && _this._grabbedManipulators.delete(o);
      });
    }
  }, {
    key: "_handlePointerEnd",
    value: function _handlePointerEnd(t, e) {
      var i = r(this._grabbedManipulators.get(t.pointerId), function (_ref4) {
        var t = _ref4.key;
        return t;
      }),
          n = this._findManipulatorByKey(i, e.forEachTool);

      o(n) && !n.dragging && (1 === this._grabbedManipulators.size && 0 === this._draggedManipulators.size && this._revertToActiveTool && (e.setActiveTool(this._currentlyActiveTool), this._revertToActiveTool = !1, this._currentlyActiveTool = null), n.grabbing && (n.grabbing = !1, n.events.emit("grab-changed", {
        action: "end",
        pointerType: t.pointerType,
        screenPoint: l(t)
      })), this._grabbedManipulators.delete(t.pointerId));
    }
  }, {
    key: "_cursorFromMap",
    value: function _cursorFromMap(e, i) {
      var _this2 = this;

      var r = null;
      return t(e, function (_ref5) {
        var t = _ref5.key;

        var e = _this2._findManipulatorByKey(t, i);

        return !!(o(e) && e.interactive && "cursor" in e && e.cursor) && (r = e.cursor, !0);
      }), r;
    }
  }, {
    key: "_updateCursor",
    value: function _updateCursor(t) {
      this._grabbedManipulators.size > 0 ? this._cursor = this._cursorFromMap(this._grabbedManipulators, t) || "grabbing" : this._hoveredManipulators.size > 0 ? this._cursor = this._cursorFromMap(this._hoveredManipulators, t) || "pointer" : this._cursor = null;
    }
  }, {
    key: "clearPointers",
    value: function clearPointers(t, e) {
      var _this3 = this;

      var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
      var n = arguments.length > 3 ? arguments[3] : undefined;

      var a = function a(e) {
        return e.tool === t && (i(n) || e.manipulatorId === n);
      };

      this._grabbedManipulators.forEach(function (_ref6, r) {
        var t = _ref6.key,
            i = _ref6.pointerType;

        if (a(t)) {
          _this3._grabbedManipulators.delete(r);

          var _n6 = _this3._findManipulatorByKey(t, e);

          o(_n6) && (_n6.grabbing = !1, _n6.events.emit("grab-changed", {
            action: "end",
            screenPoint: null,
            pointerType: i
          }));
        }
      }), this._draggedManipulators.forEach(function (_ref7, i) {
        var t = _ref7.key;

        if (a(t)) {
          _this3._draggedManipulators.delete(i);

          var _r5 = _this3._findManipulatorByKey(t, e);

          o(_r5) && (_r5.dragging = !1, _r5.events.emit("drag", {
            action: "cancel"
          }));
        }
      }), r && this._hoveredManipulators.forEach(function (_ref8, i) {
        var t = _ref8.key;

        if (a(t)) {
          _this3._hoveredManipulators.delete(i);

          var _r6 = _this3._findManipulatorByKey(t, e);

          o(_r6) && (_r6.hovering = !1);
        }
      }), this._updateCursor(e);
    }
  }, {
    key: "_intersect",
    value: function _intersect(t, e, o) {
      var r = null;
      return o(function (o) {
        if (null == o.manipulators || !s(o)) return !1;
        var n = o.manipulators.intersect(t, e);
        return !i(n) && (r = {
          manipulatorId: n.id,
          tool: o
        }, !0);
      }), r;
    }
  }, {
    key: "updateHoveredStateFromKnownPointers",
    value: function updateHoveredStateFromKnownPointers(t) {
      var _this4 = this;

      this._pointerLocations.forEach(function (e, i) {
        _this4._updateHoveredStateForPointerAtScreenPosition(a(e.x, e.y), i, e.pointerType, t);
      });
    }
  }, {
    key: "handleHoverEvent",
    value: function handleHoverEvent(t, e) {
      "pointer-up" !== t.type && "immediate-click" !== t.type && "pointer-move" !== t.type || !c(t.pointerType) || this._updateHoveredStateForPointerAtScreenPosition(l(t), t.pointerId, t.pointerType, e);
    }
  }, {
    key: "_updateHoveredStateForPointerAtScreenPosition",
    value: function _updateHoveredStateForPointerAtScreenPosition(t, e, i, a) {
      var s = this._intersect(t, i, a);

      var l = this._findManipulatorByKey(s, a);

      var _p4 = r(this._hoveredManipulators.get(e), function (_ref9) {
        var t = _ref9.key;
        return t;
      }),
          c = this._findManipulatorByKey(_p4, a);

      o(l) && !l.interactive && (l = null), c !== l && (o(c) && (c.hovering = !1), o(l) ? (l.hovering = !0, this._hoveredManipulators.set(e, {
        key: n(s)
      })) : this._hoveredManipulators.delete(e), this._updateCursor(a));
    }
  }, {
    key: "_findManipulatorByKey",
    value: function _findManipulatorByKey(t, e) {
      return this._findToolAndManipulatorByKey(t, e, h) ? h.manipulator : null;
    }
  }, {
    key: "_findToolAndManipulatorByKey",
    value: function _findToolAndManipulatorByKey(t, e, r) {
      return i(t) ? null : (r.tool = null, r.manipulator = null, e(function (e) {
        if (e !== t.tool || null == e.manipulators || !s(e)) return !1;
        var i = e.manipulators.findById(t.manipulatorId);
        return !!o(i) && (r.manipulator = i, r.tool = e, !0);
      }), r.manipulator ? r : null);
    }
  }]);

  return p;
}();

function c(t) {
  return "mouse" === t;
}

function u(t) {
  return "mouse" !== t.pointerType || 0 === t.button;
}

function d(t) {
  return !!t.native.shiftKey;
}

var h = {
  manipulator: null,
  tool: null
};
export { p as default };